<script lang="ts">
import { DateFormat, Period } from '@/framework/base/helpers/DateFormat';
import SectionApprenti from '@/generated/sections/SectionApprenti.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SectionApprenti,
    computed: {
        periodDateRupture(): Period[] {
            const min = DateFormat.toPicker(new Date(this.editApprenti.dateDebut));
            const max = DateFormat.toPicker(new Date(this.editApprenti.dateFin));
            return [new Period(min, max)]
        },
        contact() {
            return this.editApprenti;
        }
    },
    methods: {
        isDisplayed(value: string): boolean {
            let res = true;
            if (this.displayMap.size == 0) {
                const requiredAttributs = this.getRequiredAttributs();
                this.displayMap.set("CIVILITE_ID", true);
                this.displayMap.set("NOM", true);
                this.displayMap.set("PRENOM", true);
                this.displayMap.set("DATE_DEBUT", true);
                this.displayMap.set("DATE_FIN", true);
                this.displayMap.set("DATE_RUPTURE", true);
            }
            const display = this.displayMap.get(value);
            if (display != undefined) {
                res = display;
            }
            return res;
        },
        isRequired(value: string): boolean {
            let res = true;
            const requiredAttributs = this.getRequiredAttributs();
            if (this.requiredMap.size == 0) {
                this.requiredMap.set("CIVILITE_ID", true);
                this.requiredMap.set("NOM", true);
                this.requiredMap.set("PRENOM", true);
                this.requiredMap.set("DATE_DEBUT", true);
                this.requiredMap.set("DATE_FIN", true);
                this.requiredMap.set("DATE_RUPTURE", false);
            }
            const required = this.requiredMap.get(value);
            if (required != undefined) {
                res = required;
            }
            return res;
        }
    }
})

</script>
